export default __webpack_public_path__ + "static/media/top-title-en.601a90ed.png";